/* @flow */

import { registerRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import * as routes from 'src/shared/app/base/route/setting/routeSettings';

export default function useRouteRegistration() {
  // $FlowIssue: `routeSettings` exports only RouteData by convention
  registerRoutes(Object.values(routes));
}
